import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import DefMembershipActions from "../../Redux/actions/defMembership-actions";
import BusinessCustomersActions from '../../Redux/transition/customers/business-customer.reducer';
import PlanGroupActions from "../../Redux/transition/plan-group/plan-group.reducer";
import SubscriberActions from "../../Redux/transition/subscriber/subscriber.reducer";
import PaymentScheduleActions from "../../Redux/transition/payment-schedule/payment-schedule.reducer";
import { useTranslation } from "react-i18next";
import Loading from "../../Components/Loading";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import "../../Styles/pages/subscriptionDetail.scss"
import "../../Styles/pages/activities.scss";
import "../../Styles/pages/customers.scss";
import "../../Styles/pages/product.scss"
import "../../Styles/pages/subscriptions.scss"
import "../../Styles/pages/inviteSubscriber.scss"
import CustomDataTable from "../../Components/CustomDataTable";
import CustomerEdit from "../Customers/edit";
import InviteSubscriber from "../Subscriptions/Invitation/InviteSubscriber";
import { Paginator } from 'primereact/paginator';
import MarkAsPaid from "../../Components/MarkAsPaid";
import DetailCard from "./SubscriberDetailCard";
import { useDateFormatter } from "../../Components/FormatDateTime";
import { FormatCurrency, useCurrencyConstants } from '../../Components/CurrencyFormatter';
import RecordPayment from "./recordPayment";
import AutoBillingBadge from "../../Components/AutoBillingBadge";
import CollectPayment from "./collectPayment";
import LinkPlanBusinessCustomerModal from "./LinkPlanBusinessCustomerModal";
import LinkBusinessCustomerModal from "./LinkBusinessCustomerModal";
import PrimaryBusinessCustomerModal from "./PrimaryBusinessCustomerModal";
import { mergeLinkedPlansCache, planIdOf } from "./linkedPlanUtils";
import StatementOfAccountTab from "./StatementOfAccountTab";
import SubscriberToSegment from "./Segments/subscriberToSegment";
import AddSubscribersToTagDialog from "./TagComponents/AddSubscribersToTagDialog";
import RemoveSubscribersDialog from "./TagComponents/RemoveSubscribersFromTagDialog";
import { removePlusFromNum } from "../../Components/CleanInputs";
import "../../Styles/components/tags.scss";
import "../../Styles/components/segment.scss";

const SUBSCRIBER_DETAIL_MOBILE_BREAKPOINT = 1050;
const TAB_SUBSCRIPTIONS = "subscriptions";
const TAB_UPCOMING = "upcoming";
const TAB_STATEMENT = "statement";
const TAB_SECONDARIES = "secondaries";
const TAB_LINKED_PLANS = "linkedPlans";
const SUBSCRIBER_DETAIL_TABLE_ID = "subscriber-detail-table-card";

const EMPTY_RELATIONS = {
    secondaries: [],
    secondariesCount: 0,
    fetchingSecondaries: false,
    linkedPlans: [],
    linkedPlansCount: 0,
    fetchingLinkedPlans: false,
    showSecondariesCue: false,
    showLinkedPlansCue: false,
    secondariesStatsById: {},
    secondariesStatsLoading: false,
};

const toPlain = (data) => {
    if (data == null) return data;
    if (typeof data.asMutable === "function") return data.asMutable({ deep: true });
    if (typeof data.toJS === "function") return data.toJS();
    return data;
};

const BusinessCustomers = () => {
    const { formatDate, formatDateTime } = useDateFormatter();
    const { currencyFormat, currencySymbol } = useCurrencyConstants();

    const { t } = useTranslation("common");
    const navigate = useNavigate();
    const { id: customerId } = useParams();

    const [displayBasic, setDisplayBasic] = useState(false);
    const [visible, setVisible] = useState(false)
    const cancelToast = useRef(null)
    const pauseToast = useRef(null)
    const resumeToast = useRef(null)
    const rescheduleToast = useRef(null)
    const linkPlanToast = useRef(null)
    const linkCustomerToast = useRef(null)
    const prevLinkingPlanRef = useRef(false)
    const prevLinkingCustomerRef = useRef(false)
    const prevUnlinkingCustomerRef = useRef(false)
    const [confirmPause, setConfirmPause] = useState(false)
    const [confirmResume, setConfirmResume] = useState(false)
    const [selectedSubscription, setSelectedSubscription] = useState(null)
    const [confirmCancel, setConfirmCancel] = useState(false)
    const [subscriptionPicker, setSubscriptionPicker] = useState(null)
    const [confirmReschedule, setConfirmReschedule] = useState(false)
    const [confirmUnlink, setConfirmUnlink] = useState(false)
    const [relationsRefreshKey, setRelationsRefreshKey] = useState(0)
    const [relations, setRelations] = useState(EMPTY_RELATIONS)
    const [date, setDate] = useState(null);
    const [activeTabKey, setActiveTabKey] = useState(TAB_STATEMENT)
    const [visibleInvite, setVisibleInvite] = useState(false);
    const [planLinkModalOpen, setPlanLinkModalOpen] = useState(false);
    const [planLinkForm, setPlanLinkForm] = useState({ planIds: [] });
    const [planLinkSubmitAttempted, setPlanLinkSubmitAttempted] = useState(false);
    const [customerLinkModalOpen, setCustomerLinkModalOpen] = useState(false);
    const [customerLinkError, setCustomerLinkError] = useState(false);
    const [primaryModalOpen, setPrimaryModalOpen] = useState(false);
    const [isMobileStack, setIsMobileStack] = useState(
        () => typeof window !== "undefined" && window.innerWidth <= SUBSCRIBER_DETAIL_MOBILE_BREAKPOINT
    );
    const [segmentDialogVisible, setSegmentDialogVisible] = useState(false);
    const [switchSegVisible, setSwitchSegVisible] = useState(false);
    const [displayAddTag, setDisplayAddTag] = useState(false);
    const [displayRemoveTag, setDisplayRemoveTag] = useState(false);
    const [specificTagClicked, setSpecificTagClicked] = useState(null);
    const [selectedCustomers, setSelectedCustomers] = useState([]);

    const [state, setState] = useState({
        businessCustomers: null,
        count: null,
        page: 0,
        sort: "id,asc",
        loading: true,
        businessCustomerSubscriptions: [],
        businessCustomerSubscriptionAmounts: null,
        customerRecord: {
            id: "",
            firstName: "",
            lastName: "",
            customerNum: "",
            email: "",
            segment: {},
        },
        recentPaymentsObject: [],
        recentMissedPaymentsObject: [],
        recentSubscriptionActivityObject: [],
        planGroup: {},
        visibleCreate: false,
        visible: false,
        totalPendingAmount: null,
        totalMissedAmount: null,
        businessCustomerSummary: [],
        customerSummary: [],
        paused: false,
        cancelled: false,
        resumed: false,
        subscriptionId: null,
        updating: false,
        name: "",
        firstName: "",
        lastName: "",
        customerNum: "",
        email: "",
        segment: {},
        lastModifiedOn: "",
        upcomingPayments: [],
        nameError: false,
        firstNameError: false,
        lastNameError: false,
        emailError: false,
        data: null,
        key: false,
        rescheduled: false,
        totalUpcomingPaymentsCount: 0,
        successfulPaymentsObject: {},
        expiredPaymentsObject: {},
        totalCustomerSummaryCount: 0,
        id: null,
        customerExternalPayments: [],
        flex: null,
        first: 0,
        upSort: "scheduledFor,desc",
        subsSort: "subscriber.lastModifiedDate,desc",
        size: 15,
        tabChange: true,
        mount: false,
        showRecordPopup: false,
        showCollectPopup: false,
        currentSubscription: null,
        onSubscriptionsTable: false,
        oneOffOnly: false
    })

    const routeChange = (pathname, state) => {
        navigate(pathname, state)
    };

    //Redux State from Store
    const defMembership = useSelector((state) => state.defMembership.defMembership);
    const businessCustomerSubscriptions = useSelector((state) => state.businessCustomers.businessCustomerSubcriptions)
    const fetchingCustomerSubscriptions = useSelector((state) => state.businessCustomers.fetchingbusinessCustomerSubscriptions)
    const fetchingCustomerCollectedPayments = useSelector((state) => state.businessCustomers.fetchingSuccessfulPayments)
    const businessCustomerRecord = useSelector((state) => state.businessCustomers.businessCustomerRecord)
    const fetchingCustomerRecord = useSelector((state) => state.businessCustomers.fetchingBusinessCustomerRecord)
    const recentPayments = useSelector((state) => state.businessCustomers.recentPayments)
    const recentMissedPayments = useSelector((state) => state.businessCustomers.recentMissedPayments)
    const recentSubscriptionActivity = useSelector((state) => state.businessCustomers.recentSubscriptionActivity)
    const customerPendingPayments = useSelector((state) => state.businessCustomers.customerPendingPayments)
    const customerReceivedPayments = useSelector((state) => state.businessCustomers.customerReceivedPayments)
    const cancelledSubscription = useSelector((state) => state.subscribers.cancelledSubscription)
    const cancellingSubscription = useSelector((state) => state.subscribers.cancellingSubscription)
    const pausingSubscription = useSelector((state) => state.subscribers.pausingSubscription)
    const pausedSubscription = useSelector((state) => state.subscribers.pausedSubscription)
    const resumingSubscription = useSelector((state) => state.subscribers.resumingSubscription)
    const resumedSubscription = useSelector((state) => state.subscribers.resumedSubscription)
    const rescheduledSubscription = useSelector((state) => state.subscribers.rescheduledSubscription)
    const reschedulingSubscription = useSelector((state) => state.subscribers.reschedulingSubscription)
    const fetchingCustomerReceivedPayments = useSelector((state) => state.businessCustomers.fetchingCustomerReceivedPayments)
    const businessCustomerPayments = useSelector((state) => state.paymentTracks.businessCustomerPayments)
    const allUpcomingPaymentSchedules = useSelector((state) => state.paymentSchedules.paymentSchedulesPending);
    const fetchingPending = useSelector((state) => state.paymentSchedules.fetchingPending);
    const businessCustomerSubscriptionAmounts = useSelector((state) => state.businessCustomers.businessCustomerSubscriptionAmounts);
    const customerSummary = useSelector((state) => state.businessCustomers.customerSummary);
    const linkingPlan = useSelector((state) => state.businessCustomers.linkingPlanWithBusinessCustomer);
    const errorLinkingPlan = useSelector((state) => state.businessCustomers.errorLinkPlanWithBusinessCustomer);
    const linkingCustomer = useSelector((state) => state.businessCustomers.linkingBusinessCustomerToPrimary);
    const errorLinkingCustomer = useSelector((state) => state.businessCustomers.errorLinkBusinessCustomerToPrimary);
    const unlinkingCustomer = useSelector((state) => state.businessCustomers.unlinkingBusinessCustomerFromPrimary);
    const errorUnlinkingCustomer = useSelector((state) => state.businessCustomers.errorUnlinkBusinessCustomerFromPrimary);
    const planGroupsGraphedAll = useSelector((state) => state.planGroups.planGroupsGraphedAll);
    const fetchingPlans = useSelector((state) => state.planGroups.fetchingGraphedAll);

    //Dispatch Actions
    const dispatch = useDispatch();
    const getMembership = useCallback(() => { dispatch(DefMembershipActions.defMembershipRequest()) }, [dispatch]);
    const getEnterpriseCustomers = useCallback((businessId) => dispatch(BusinessCustomersActions.businessCustomerAllRequest(businessId)), [dispatch]);
    const getBusinessCustomerSubscriptions = useCallback((businessCustomerId) => dispatch(BusinessCustomersActions.businessCustomerSubscriptionsRequest(businessCustomerId)), [dispatch]);
    const getBusinessCustomerRecord = useCallback((businessCustomerId) => dispatch(BusinessCustomersActions.businessCustomerRecordRequest(businessCustomerId)), [dispatch]);
    const getCustomerSummary = useCallback((bcId) => dispatch(BusinessCustomersActions.customerSummaryRequest(bcId)), [dispatch]);
    const getRecentCustomerPayments = useCallback((businessCustomerId, size) => dispatch(BusinessCustomersActions.businessCustomerPaymentsRequest(businessCustomerId, size)), [dispatch]);
    const getRecentMissedCustomerPayments = useCallback((businessCustomerId, size) => dispatch(BusinessCustomersActions.businessCustomerMissedPaymentsRequest(businessCustomerId, size)), [dispatch]);
    const getRecentSubscriptionActivity = useCallback((businessCustomerId, size) => dispatch(BusinessCustomersActions.businessCustomerSubscriptionActivityRequest(businessCustomerId, size)), [dispatch]);
    const getCustomerPendingPayments = useCallback((businessCustomerId) => dispatch(BusinessCustomersActions.customerPendingPaymentRequest(businessCustomerId)), [dispatch]);
    const getCustomerReceivedPayments = useCallback((businessCustomerId, options) => dispatch(BusinessCustomersActions.customerReceivedPaymentRequest(businessCustomerId, options)), [dispatch]);
    const cancelSubscriptions = useCallback((subscriptionId, membershipId) => { dispatch(SubscriberActions.cancelSubscriptionRequest(subscriptionId, membershipId)) }, [dispatch])
    const pauseSubscriptions = useCallback((subscriptionId, membershipId) => { dispatch(SubscriberActions.pauseSubscriptionRequest(subscriptionId, membershipId)) }, [dispatch])
    const resumeSubscriptions = useCallback((id, startFrom, membershipId, action) => { dispatch(SubscriberActions.resumeSubscriptionRequest(id, startFrom, membershipId, action)) }, [dispatch])
    const rescheduleSubscriptions = useCallback((subscriberId, startFrom, membershipId) => { dispatch(SubscriberActions.rescheduleSubscriptionRequest(subscriberId, startFrom, membershipId)) }, [dispatch])
    const getBusinessCustomerUpcomingPayments = useCallback((subscriberId, options) => { dispatch(PaymentScheduleActions.paymentSchedulePendingRequest(subscriberId, options)) }, [dispatch]);
    const getBusinessCustomerSubscriptionAmounts = useCallback((bcId) => { dispatch(BusinessCustomersActions.businessCustomerSubscriptionAmountsRequest(bcId)) }, [dispatch])
    const getPlanGroupsGraphedAll = useCallback((businessId) => dispatch(PlanGroupActions.planGroupGraphedAllRequest(businessId)), [dispatch]);
    const getSegment = useCallback(
        (businessId) =>
            dispatch(
                BusinessCustomersActions.fetchingSegmentRequest(businessId, {
                    page: 0,
                    size: 1000,
                    sort: "createdDate,desc",
                })
            ),
        [dispatch]
    );

    const refreshCustomerSegmentAndTags = useCallback(() => {
        if (!customerId) return;
        getBusinessCustomerRecord(customerId);
        getCustomerSummary(customerId);
    }, [customerId, getBusinessCustomerRecord, getCustomerSummary]);

    const buildRowSubClicked = useCallback(() => ({
        id: customerId,
        businessCustomer: {
            id: customerId,
            name: state.customerRecord?.name,
            segment: state.customerRecord?.segment?.id ? state.customerRecord.segment : null,
        },
        tags: state.customerSummary?.tags || [],
    }), [customerId, state.customerRecord?.name, state.customerRecord?.segment, state.customerSummary?.tags]);

    const handleOpenSegmentDialog = useCallback(() => {
        const hasSegment = !!state.customerRecord?.segment?.id;
        setSwitchSegVisible(hasSegment);
        setSegmentDialogVisible(true);
        if (defMembership?.business?.id) {
            getSegment(defMembership.business.id);
        }
    }, [state.customerRecord?.segment?.id, defMembership?.business?.id, getSegment]);

    const handleOpenAddTag = useCallback(() => {
        setDisplayAddTag(true);
    }, []);

    const handleOpenRemoveTag = useCallback((tag = null) => {
        setSpecificTagClicked(tag);
        setDisplayRemoveTag(true);
    }, []);

    useEffect(() => {
        if (!defMembership) {
            getMembership();
            setState((state) => {
                return {
                    ...state,
                    mount: true
                }
            })
        }
        if (defMembership) {
            getEnterpriseCustomers(defMembership.business.id)
            getBusinessCustomerSubscriptions(customerId)
            getBusinessCustomerRecord(customerId)
            getCustomerSummary(customerId);
            getRecentCustomerPayments(customerId, "3")
            getRecentMissedCustomerPayments(customerId, "3")
            getRecentSubscriptionActivity(customerId, "3")
            getBusinessCustomerUpcomingPayments(customerId, { sort: state.upSort, size: state.size })
            getCustomerReceivedPayments(customerId, { sort: state.subsSort, size: state.size })
            getCustomerPendingPayments(customerId)
            getBusinessCustomerSubscriptionAmounts(customerId)
            getSegment(defMembership.business.id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const prevCustomerIdRef = useRef(customerId);
    useEffect(() => {
        if (!defMembership || !customerId || prevCustomerIdRef.current === customerId) {
            return;
        }
        prevCustomerIdRef.current = customerId;
        setActiveTabKey(TAB_STATEMENT);
        setRelations(EMPTY_RELATIONS);
        setState((prev) => ({ ...prev, page: 0, first: 0 }));
        getEnterpriseCustomers(defMembership.business.id);
        getBusinessCustomerSubscriptions(customerId);
        getBusinessCustomerRecord(customerId);
        getCustomerSummary(customerId);
        getRecentCustomerPayments(customerId, "3");
        getRecentMissedCustomerPayments(customerId, "3");
        getRecentSubscriptionActivity(customerId, "3");
        getBusinessCustomerUpcomingPayments(customerId, { sort: state.upSort, size: state.size });
        getCustomerReceivedPayments(customerId, { sort: state.subsSort, size: state.size });
        getCustomerPendingPayments(customerId);
        getBusinessCustomerSubscriptionAmounts(customerId);
        getSegment(defMembership.business.id);
        setRelationsRefreshKey((key) => key + 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId, defMembership]);

    const membershipId = defMembership?.id;
    const calenderDateFormat = defMembership?.business?.country?.jsShortDateFormat;
    const countryCurrency = defMembership?.business?.country?.currency;

    const planGroupsForLink = useMemo(() => {
        const plain = toPlain(planGroupsGraphedAll);
        const groups = plain?.groups;
        if (!Array.isArray(groups)) return [];
        return groups
            .map((groupItem) => {
                const planGroup = groupItem.group || groupItem;
                return {
                    id: planGroup?.id ?? groupItem.id,
                    name: planGroup?.name ?? groupItem.name ?? "",
                    plans: groupItem.plans || [],
                };
            })
            .filter((group) => group.plans.length > 0)
            .sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    }, [planGroupsGraphedAll]);

    const recentSubPlan = useMemo(() => {
        const subs = state.businessCustomerSubscriptions;
        if (!Array.isArray(subs) || !subs.length) return null;
        return subs[0]?.subscriber?.plan?.name ?? subs[0]?.subscription?.plan?.name ?? null;
    }, [state.businessCustomerSubscriptions]);

    const refreshSubscriberDetail = useCallback(() => {
        getBusinessCustomerSubscriptions(customerId);
        getBusinessCustomerRecord(customerId);
        getCustomerSummary(customerId);
        getRecentSubscriptionActivity(customerId, "3");
        getBusinessCustomerSubscriptionAmounts(customerId);
        getCustomerReceivedPayments(customerId, { sort: state.subsSort, size: state.size });
        getBusinessCustomerUpcomingPayments(customerId, { sort: state.upSort, size: state.size });
        setRelationsRefreshKey((key) => key + 1);
    }, [
        customerId,
        getBusinessCustomerSubscriptions,
        getBusinessCustomerRecord,
        getCustomerSummary,
        getRecentSubscriptionActivity,
        getBusinessCustomerSubscriptionAmounts,
        getCustomerReceivedPayments,
        getBusinessCustomerUpcomingPayments,
        state.subsSort,
        state.size,
        state.upSort,
    ]);

    const closePlanLinkModal = useCallback(() => {
        setPlanLinkModalOpen(false);
        setPlanLinkForm({ planIds: [] });
        setPlanLinkSubmitAttempted(false);
    }, []);

    const openPlanLinkModal = useCallback(() => {
        setPlanLinkForm({ planIds: [] });
        setPlanLinkSubmitAttempted(false);
        setPlanLinkModalOpen(true);
        if (defMembership?.business?.id) {
            getPlanGroupsGraphedAll(defMembership.business.id);
        }
    }, [defMembership, getPlanGroupsGraphedAll]);

    const handlePlanLinkSubmit = useCallback(() => {
        setPlanLinkSubmitAttempted(true);
        if (!planLinkForm.planIds?.length || !customerId) {
            return;
        }
        dispatch(
            BusinessCustomersActions.linkPlanWithBusinessCustomerRequest(
                planLinkForm.planIds,
                customerId
            )
        );
    }, [dispatch, planLinkForm.planIds, customerId]);

    const linkedToPrimary = useMemo(() => {
        return Boolean(
            state.customerRecord?.linkedToPrimary ??
            state.customerSummary?.businessCustomer?.linkedToPrimary ??
            false
        );
    }, [state.customerRecord, state.customerSummary]);

    const primaryCustomerId = useMemo(() => {
        return (
            state.customerRecord?.primaryCustomerId ??
            state.customerSummary?.businessCustomer?.primaryCustomerId ??
            null
        );
    }, [state.customerRecord, state.customerSummary]);

    const closeCustomerLinkModal = useCallback(() => {
        setCustomerLinkModalOpen(false);
        setCustomerLinkError(false);
    }, []);

    const openCustomerLinkModal = useCallback(() => {
        setCustomerLinkError(false);
        setCustomerLinkModalOpen(true);
    }, []);

    const handleLinkPrimaryCustomer = useCallback(
        (primaryBcId) => {
            if (!customerId || !primaryBcId) return;
            if (String(customerId) === String(primaryBcId)) {
                setCustomerLinkError(true);
                return;
            }
            setCustomerLinkError(false);
            dispatch(
                BusinessCustomersActions.linkBusinessCustomerToPrimaryRequest(
                    customerId,
                    primaryBcId
                )
            );
        },
        [dispatch, customerId]
    );

    const handleUnlinkCustomer = useCallback(() => {
        if (!customerId || unlinkingCustomer) return;
        dispatch(
            BusinessCustomersActions.unlinkBusinessCustomerFromPrimaryRequest(customerId)
        );
    }, [dispatch, customerId, unlinkingCustomer]);

    const openUnlinkConfirm = useCallback(() => {
        if (unlinkingCustomer) return;
        setConfirmUnlink(true);
    }, [unlinkingCustomer]);

    const openPrimaryModal = useCallback(() => {
        if (!primaryCustomerId) return;
        setPrimaryModalOpen(true);
    }, [primaryCustomerId]);

    const closePrimaryModal = useCallback(() => {
        setPrimaryModalOpen(false);
    }, []);

    useEffect(() => {
        if (prevLinkingPlanRef.current && !linkingPlan && planLinkModalOpen) {
            if (!errorLinkingPlan) {
                mergeLinkedPlansCache(
                    customerId,
                    (planLinkForm.planIds || []).map((id) => ({ id }))
                );
                closePlanLinkModal();
                refreshSubscriberDetail();
                window.setTimeout(() => refreshSubscriberDetail(), 600);
                linkPlanToast.current?.show({
                    severity: "success",
                    summary: t("success"),
                    detail: t("business_customers.plan_link_success"),
                    life: 3000,
                });
            }
        }
        prevLinkingPlanRef.current = linkingPlan;
    }, [
        linkingPlan,
        errorLinkingPlan,
        planLinkModalOpen,
        closePlanLinkModal,
        refreshSubscriberDetail,
        t,
        customerId,
        planLinkForm.planIds,
    ]);

    useEffect(() => {
        if (prevLinkingCustomerRef.current && !linkingCustomer && customerLinkModalOpen) {
            if (!errorLinkingCustomer) {
                closeCustomerLinkModal();
                refreshSubscriberDetail();
                linkCustomerToast.current?.show({
                    severity: "success",
                    summary: t("success"),
                    detail: t("business_customers.link_customer_success"),
                    life: 3000,
                });
            } else {
                setCustomerLinkError(true);
            }
        }
        prevLinkingCustomerRef.current = linkingCustomer;
    }, [
        linkingCustomer,
        errorLinkingCustomer,
        customerLinkModalOpen,
        closeCustomerLinkModal,
        refreshSubscriberDetail,
        t,
    ]);

    useEffect(() => {
        if (prevUnlinkingCustomerRef.current && !unlinkingCustomer) {
            setConfirmUnlink(false);
            if (!errorUnlinkingCustomer) {
                refreshSubscriberDetail();
                linkCustomerToast.current?.show({
                    severity: "success",
                    summary: t("success"),
                    detail: t("business_customers.unlink_customer_success"),
                    life: 3000,
                });
            } else {
                linkCustomerToast.current?.show({
                    severity: "error",
                    summary: t("err"),
                    detail: t("business_customers.unlink_customer_error"),
                    life: 4000,
                });
            }
        }
        prevUnlinkingCustomerRef.current = unlinkingCustomer;
    }, [unlinkingCustomer, errorUnlinkingCustomer, refreshSubscriberDetail, t]);

    useEffect(() => {
        if (businessCustomerSubscriptions) {
            setState((state) => {
                return {
                    ...state,
                    businessCustomerSubscriptions,
                    loading: false,
                }
            })
        }
        if (businessCustomerRecord) {
            setState((state) => {
                return {
                    ...state,
                    customerRecord: businessCustomerRecord
                }
            })
        }
        if (customerSummary) {
            setState((state) => {
                return {
                    ...state,
                    customerSummary
                }
            })
        }
        if (recentPayments) {
            setState((state) => {
                return { ...state, recentPaymentsObject: recentPayments }
            })
        }
        if (recentMissedPayments) {
            setState((state) => { return { ...state, recentMissedPaymentsObject: recentMissedPayments } })
        }
        if (recentSubscriptionActivity) {
            setState((state) => { return { ...state, recentSubscriptionActivityObject: recentSubscriptionActivity } })
        }
        if (customerPendingPayments) {
            setState((state) => { return { ...state, totalPendingAmount: customerPendingPayments } })
        }
        if (allUpcomingPaymentSchedules) {
            setState((state) => ({ ...state, upcomingPayments: allUpcomingPaymentSchedules?.content, totalUpcomingPaymentsCount: allUpcomingPaymentSchedules?.totalElements }))
        }

        if (customerReceivedPayments) {
            setState((state) => {
                return {
                    // ...state, customerSummary: customerReceivedPayments?.content,
                    ...state, businessCustomerSummary: customerReceivedPayments?.content,
                    totalCustomerSummaryCount: customerReceivedPayments?.totalElements
                }
            })
        }
        if (businessCustomerPayments) {
            setState((state) => { return { ...state, customerExternalPayments: businessCustomerPayments?.content } })
        }
        if (businessCustomerSubscriptionAmounts) {
            setState((state) => {
                return { ...state, businessCustomerSubscriptionAmounts }
            })
        }
    }, [businessCustomerSubscriptions,
        businessCustomerRecord,
        recentPayments,
        customerReceivedPayments,
        recentMissedPayments,
        customerPendingPayments,
        recentSubscriptionActivity,
        businessCustomerPayments,
        state.customerExternalPayments,
        businessCustomerSubscriptionAmounts,
        allUpcomingPaymentSchedules,
        customerSummary
    ])

    useEffect(() => {
        if (!cancellingSubscription && cancelledSubscription && state.cancelled) {
            setState((state) => { return { ...state, cancelled: false, response: cancelledSubscription } })
            setConfirmCancel(false)
            cancelSuccess()
            refreshSubscriberDetail()
        }
        if (!pausingSubscription && pausedSubscription && state.paused) {
            setState((state) => { return { ...state, paused: false } })
            setConfirmPause(false)
            pauseSuccess()
            refreshSubscriberDetail()
        }
        if (!resumingSubscription && state.key && state.resumed) {
            setState((state) => { return { ...state, resumed: false, key: false } })
            setConfirmResume(false)
            resumeSuccess()
            refreshSubscriberDetail()
        }
        if (!reschedulingSubscription && state.key && state.rescheduled) {
            setConfirmReschedule(false)
            setState((state) => { return { ...state, rescheduled: false, key: false } })
            rescheduleSuccess()
            refreshSubscriberDetail()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cancellingSubscription, state.cancelled, pausingSubscription, pausedSubscription, state.paused, state.tabChange,
        resumingSubscription, resumedSubscription, state.resumed, state.key, state.rescheduled, rescheduledSubscription, state.mount])

    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${SUBSCRIBER_DETAIL_MOBILE_BREAKPOINT}px)`);
        const onBreakpointChange = (event) => setIsMobileStack(event.matches);
        onBreakpointChange(mediaQuery);
        mediaQuery.addEventListener("change", onBreakpointChange);
        return () => mediaQuery.removeEventListener("change", onBreakpointChange);
    }, []);

    useEffect(() => {
        if (activeTabKey === TAB_UPCOMING) {
            getBusinessCustomerUpcomingPayments(customerId, { sort: state.upSort, size: state.size })
        } else if (activeTabKey === TAB_SUBSCRIPTIONS) {
            getCustomerReceivedPayments(customerId, { sort: state.subsSort, size: state.size })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTabKey])

    const prevRelationCuesRef = useRef({
        secondaries: false,
        linkedPlans: false,
    });

    useEffect(() => {
        const wasShowingSecondaries = prevRelationCuesRef.current.secondaries;
        const wasShowingLinkedPlans = prevRelationCuesRef.current.linkedPlans;
        prevRelationCuesRef.current = {
            secondaries: relations.showSecondariesCue,
            linkedPlans: relations.showLinkedPlansCue,
        };
        if (activeTabKey === TAB_SECONDARIES && wasShowingSecondaries && !relations.showSecondariesCue) {
            setActiveTabKey(TAB_STATEMENT);
        } else if (activeTabKey === TAB_LINKED_PLANS && wasShowingLinkedPlans && !relations.showLinkedPlansCue) {
            setActiveTabKey(TAB_STATEMENT);
        }
    }, [activeTabKey, relations.showSecondariesCue, relations.showLinkedPlansCue])

    const handleRelationsChange = useCallback((nextRelations) => {
        setRelations((prev) => {
            const incomingCount = nextRelations?.linkedPlansCount || 0;
            const linkedPlansCount = nextRelations?.fetchingLinkedPlans
                ? Math.max(prev.linkedPlansCount || 0, incomingCount)
                : incomingCount > 0 ? incomingCount : Math.max(prev.linkedPlansCount || 0, incomingCount);
            return {
                ...EMPTY_RELATIONS,
                ...prev,
                ...nextRelations,
                linkedPlansCount,
                showLinkedPlansCue: linkedPlansCount > 0,
            };
        });
    }, [])

    if (fetchingCustomerRecord && !state.customerRecord?.id) {
        return <Loading />
    }

    const dateFormat = (date) => {
        return <div>
            <p className="mb-0 mt-1 date">{formatDateTime(date)}</p>
        </div>
    }


    // toast for when a subscription is cancelled successfully
    const cancelSuccess = () => {
        cancelToast.current.show({ severity: 'success', summary: t('success'), detail: t('subscriber.cancelled'), life: 3000 })
    }

    // toast for when a subscription is paused successfully
    const pauseSuccess = () => {
        pauseToast.current.show({ severity: 'success', summary: t('success'), detail: t('subscriber.paused'), life: 3000 })
    }

    // toast for when a subscription is resumed successfully
    const resumeSuccess = () => {
        resumeToast.current.show({ severity: 'success', summary: t('success'), detail: t('subscriber.resumed'), life: 3000 })
    }

    const rescheduleSuccess = () => {
        rescheduleToast.current.show({ severity: 'success', summary: t('success'), detail: t('subscriber.rescheduled'), life: 3000 })
    }

    const paymentBodyTemplate = (rowData) => {
        if (rowData) {
            return <div className="subscriptionBodyTemplate subscriptionBodyTemplate_customers">
                {
                    rowData ?
                        <div>
                            <span className="successCount_span">
                                {rowData.subscriber.successCount !== null ? rowData.subscriber.successCount : "0"}
                            </span>
                            <span className="num_payments">{t("common.payments")}</span>
                        </div> : ""
                }
                <div>
                    <FormatCurrency
                        amount={rowData.collectedAmount}
                        currencySymbol={currencySymbol}
                        currencyFormat={currencyFormat}
                        className="business-customer-amnt"
                    />
                    <span className="cus_payments">{" "}  {t("business_customers.paid")}</span>
                </div>
                <div>
                    <FormatCurrency
                        amount={rowData.redeemable}
                        currencySymbol={currencySymbol}
                        currencyFormat={currencyFormat}
                        className="tier-customer-amnt-text pr-1"
                    />
                    <span className="cus_revenue">{t("common.revenue")}</span>
                </div>
                <div>
                    {rowData.subscriber.plan.flex ?
                        <div><span className="missed_count_number">{rowData.missedCount}</span> <span className="missed_count">{t("subscriber.missed")}</span></div> :
                        <div>
                            <FormatCurrency
                                amount={rowData.missedAmount}
                                currencySymbol={currencySymbol}
                                currencyFormat={currencyFormat}
                                className="business-customer-missed-amnt-text pr-1"
                            />
                            <span className="cus_missed">{t("business_customers.missed")}</span>
                        </div>
                    }
                </div>
                {
                    rowData.status === "ACTIVE" || rowData.status === "PAUSED" ?
                        <div >
                            <span className="cus_next_payment"> {t("subscriber.next_payment")}</span>
                            <span className="cus_time">{formatDateTime(rowData.subscriber?.nextBillingDate)}</span>
                        </div> : null
                }
            </div>
        }
    }
    const scheduledForBodyTemplate = (rowData) => {
        return <div className="flex flex-column align-items-start scheduleed">
            <p className={`subscription-status scheduleed-status-box status-${rowData.status}`}>
                {rowData.status.toUpperCase()}</p>
            <p className="scheduleed-title mb-2">{t("subscriber.scheduled_for")}</p>
            <p className="mb-0 scheduleed-date">{rowData.scheduledFor ? formatDateTime(rowData.scheduledFor) : "null"}</p>
        </div>
    }

    const subscriptionsBodyTemplate = (rowData) => {
        return <div className="flex flex-column align-items-start cust">
            <p className="mb-0 cust-num">{rowData?.subscription?.plan?.name}</p>
            <p className="mb-0 pb-0 cust-name">{rowData?.subscription?.businessCustomer?.name}</p>
            <p className="mb-0 pb-0 cust-phoneNo">{rowData?.subscription?.businessCustomer?.phoneNo}</p>
        </div>
    }

    const upcomingAmount = (rowData) => {
        return <div className="flex flex-column align-items-start">
            {rowData?.subscription?.plan?.flex ? <p className="upcoming-amount">{t("business_customers.flex")}</p>
                : <FormatCurrency
                    amount={rowData.cost}
                    currencySymbol={currencySymbol}
                    currencyFormat={currencyFormat}
                    className="upcoming-amount"
                />
            }
        </div>
    }

    const statusBodyTemplate = (rowData) => {
        if (rowData.status === "ACTIVE") {
            return <div className="subscriptionBodyTemplate subscriptionBodyTemplate_customers">
                <div className="status-date-content" >
                    <span className={`status-outline status-${(rowData.status ? rowData.status.toLowerCase() : '')} status_body`}>{rowData.status}
                    </span>
                </div>
                <div className="status-date-content">
                    <p>{dateFormat(rowData?.subscriber?.lastModifiedDate ? rowData?.subscriber?.lastModifiedDate : rowData.subscriber?.createdDate)}</p>
                </div>
            </div>
        } else if (["CANCELLED", "FAILED"].includes(rowData.status)) {
            return <div className="subscriptionBodyTemplate subscriptionBodyTemplate_customers">
                <div className="status-date-content">
                    <span className={`status-outline status-${(rowData.status ? rowData.status.toLowerCase() : '')} status_body `}>{rowData.status}</span>
                </div>
                <p>{dateFormat(rowData?.subscriber?.lastModifiedDate ? rowData?.subscriber?.lastModifiedDate : rowData.subscriber?.cancelledOn)}</p>
            </div>
        } else if (rowData.status === "PAUSED") {
            return <div className="subscriptionBodyTemplate subscriptionBodyTemplate_customers">
                <div className="status-date-content">
                    <span className={`status-outline status-${(rowData.status ? rowData.status.toLowerCase() : '')} status_body `}>{rowData.status}</span>
                </div>
                <p>{dateFormat(rowData?.subscriber?.lastModifiedDate ? rowData?.subscriber?.lastModifiedDate : rowData.subscriber?.pausedOn)}</p>
            </div>
        } else if (rowData.status === "COMPLETE") {
            return <div className="subscriptionBodyTemplate subscriptionBodyTemplate_customers">
                <div className="status-date-content">
                    <span className={`status-outline status-${(rowData.status ? rowData.status.toLowerCase() : '')} status_body `}>{rowData.status}</span>
                </div>
                <p>{dateFormat(rowData?.subscriber?.lastModifiedDate ? rowData?.subscriber?.lastModifiedDate : rowData.subscriber?.completedOn)}</p>
            </div>
        } else {
            return ""
        }
    }

    const subscriptionBodyTemplate = (rowData) => {
        if (rowData) {
            return <div>
                <div className="subscriptionMainBodyTemplate subscriptionBodyTemplate_customers">
                    <span className="flex">
                        {rowData?.subscriber?.plan.policy === "TARGET" ? <>
                            <p className="text-left policy mb-0 mr-2">{t('billing', { val: rowData?.subscriber?.plan.policy })}</p>
                            <p className="text-left policy target-stat mb-0 mr-1">{rowData.subscriber?.plan.targetEqualParts ? t("product.equal") : t("product.varying")}</p>
                            {(rowData?.subscriber?.plan.targetEqualParts && rowData?.subscriber?.plan.recoverMissed) && <p className="text-left policy target-stat-miss mb-0">{t('product.recovery')}</p>}
                        </>
                            :
                            <p className="text-left policy mb-0">{rowData?.subscriber?.plan.policy === "FIXED" ? t("products.fixed_billing").toUpperCase() : rowData?.subscriber?.plan.policy === "CUSTOM" ? t("products.custom_billing").toUpperCase() : t('billing', { val: rowData?.subscriber?.plan.policy })}</p>
                        }
                    </span>
                    {
                        rowData.subscriber.subscriberReference !== null ?
                            <p className="reference-text-customers detail-navigation mb-0" id="planName"
                                onClick={() => {
                                    if (rowData.id)
                                        routeChange(`/crm/customers/customer/subscription/${rowData.id}`, rowData);
                                }}
                            >
                                {rowData.subscriber.subscriberReference}</p>
                            : ""
                    }
                    {
                        rowData.subscriber.plan.name ?
                            <div className="flex align-items-center gap-2">
                                <span className="detail-navigation tier-name-content"
                                    onClick={() => {
                                        navigate(`/products/plan/detail/${rowData.planId}`)
                                    }
                                    }
                                >
                                    {rowData.subscriber.plan.group.name !== null ? rowData.subscriber.plan.name : ""}
                                </span>
                                <AutoBillingBadge collectionMode={rowData.subscriber.plan.collectionMode} />
                            </div> : null
                    }
                    {
                        rowData.subscriber?.plan?.billingPeriod ?
                            <span className="plan-group-text">
                                {rowData.subscriber.plan.billingPeriod !== null ? t(`product.${rowData.subscriber.plan.billingPeriod.toLowerCase()}`) : ""}
                            </span> : null
                    }
                    {
                        rowData.subscriber.plan.groupName &&
                        <span className="plan-text detail-navigation hov"
                            onClick={() => {
                                navigate(`/products/detail/${rowData.groupId}`)
                            }}> {rowData.subscriber.plan.groupName} </span>
                    }
                    {rowData.subscriber.plan.setup && <div className="setup_fee_main_div setup_pt">
                        <span className="setup_fee_tag">{t("common.setup_fee_label")}</span>
                        <FormatCurrency
                            amount={rowData.subscriber.plan.setup}
                            currencySymbol={currencySymbol}
                            currencyFormat={currencyFormat}
                            className="setup_fee_value"
                        />
                    </div>}
                </div >
            </div >
        }
    }

    const amountTemplate = (rowData) => {
        if (rowData.subscriber.plan?.policy === "SCHEDULE") {
            return "null"
        } else if (rowData.subscriber.plan?.policy === "CUSTOM") {
            return <div>
                {rowData.subscriber.cost !== null &&
                    <FormatCurrency
                        amount={rowData.subscriber.cost}
                        currencySymbol={currencySymbol}
                        currencyFormat={currencyFormat}
                        className="" />
                }
            </div>
        } else if (rowData.subscriber.plan?.policy === "TARGET") {
            return <FormatCurrency
                amount={rowData.subscriber.target}
                currencySymbol={currencySymbol}
                currencyFormat={currencyFormat}
                className="" />
        }
        else if (rowData.subscriber.plan?.policy === "FIXED" && rowData.subscriber.plan.flex === false) {
            return <div>
                {rowData.subscriber.plan.cost !== null &&
                    <FormatCurrency
                        amount={rowData.subscriber.plan.cost}
                        currencySymbol={currencySymbol}
                        currencyFormat={currencyFormat}
                        className="" />
                }
            </div>
        }
    };

    const actionBodyTemplate = (rowData) => {
        if (rowData) {
            return <div className="actionBodyTemplate_div">
                {rowData.status &&
                    <div>
                        <Button
                            icon={"pi pi-info-circle"}
                            className="p-button action-button"
                            tooltip={t("product.details")}
                            onClick={() => {
                                if (rowData.id)
                                    routeChange(`/crm/customers/customer/subscription/${rowData.id}`, rowData);
                            }}
                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15, }}>
                        </Button>
                    </div>
                }
                {
                    (rowData.status === "ACTIVE") && (defMembership?.role !== "VIEWER") &&
                    <div>
                        <Button
                            icon={rowData.status === "ACTIVE" && "pi pi-calendar"}
                            className="p-button action-button"
                            tooltip={t('subscriber.reschedule')}
                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15, }}
                            onClick={() => {
                                setConfirmReschedule(true)
                                setState((state) => { return { ...state, subscriptionId: rowData.id } })
                            }}
                        />
                    </div>
                }
                {
                    (rowData.status === "ACTIVE") && (defMembership?.role !== "VIEWER") &&
                    <div>
                        <Button
                            icon={rowData.status === "ACTIVE" && "pi pi-pause"}
                            className="p-button action-button"
                            tooltip={t("subscriber.pause_label")}
                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15, }}
                            onClick={() => {
                                setConfirmPause(true)
                                setState((state) => { return { ...state, subscriptionId: rowData.id } })
                            }}
                        />
                    </div>
                }
                {
                    (rowData.status === "PAUSED") && (defMembership?.role !== "VIEWER") &&
                    <div>
                        <Button
                            icon={rowData.status === "PAUSED" && "pi pi-refresh"}
                            className="p-button action-button"
                            tooltip={t("subscriber.resume_label")}
                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15, }}
                            onClick={() => {
                                setSelectedSubscription(subscriptionChoice(rowData))
                                setConfirmResume(true)
                                setState((state) => { return { ...state, subscriptionId: rowData.id } })
                            }}
                        />
                    </div>
                }
                <div>
                    {(rowData.status === "ACTIVE" || rowData.status === "PAUSED") && (defMembership?.role !== "VIEWER") &&
                        <Button icon={"pi pi-times-circle"}
                            className="p-button action-button"
                            tooltip={t("subscriber.cancel_label")}
                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15, }}
                            onClick={() => {
                                setConfirmCancel(true)
                                setState((state) => { return { ...state, subscriptionId: rowData.id } })
                            }}
                        />}
                </div>
                {(["FIXED", "FLEXIBLE"].includes(rowData.subscriber?.plan?.policy) && rowData.status === "ACTIVE") &&
                    (defMembership?.role !== "VIEWER") && (rowData.subscriber?.plan?.billingPeriod !== "ONCE") && <div>
                        <Button
                            icon="pi pi-dollar"
                            className="p-button-warning p-button-rounded p-button-text mr-2 customerAction"
                            style={{ cursor: "pointer" }}
                            tooltip={t("business_customers.collect_payment")}
                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                            onClick={() => {
                                setState(prev => ({ ...prev, showCollectPopup: true, currentSubscription: rowData, onSubscriptionsTable: true }))
                            }}
                        />
                        <Button
                            icon="pi pi-book"
                            className="p-button-warning p-button-rounded p-button-text mr-2 customerAction"
                            style={{ cursor: "pointer" }}
                            tooltip={t("business_customers.record_pay")}
                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                            onClick={() => {
                                setState(prev => ({ ...prev, showRecordPopup: true, currentSubscription: rowData, onSubscriptionsTable: true }))
                            }}
                        />
                    </div>}
            </div >
        }
    }

    const subscriptionsMobileSummary = (rowData) => (
        <div className="subscriber-detail-mobile-summary">
            <div className="subscriber-detail-mobile-section">{statusBodyTemplate(rowData)}</div>
            <div className="subscriber-detail-mobile-section">{subscriptionBodyTemplate(rowData)}</div>
            <div className="subscriber-detail-mobile-section">{amountTemplate(rowData)}</div>
            <div className="subscriber-detail-mobile-section">{paymentBodyTemplate(rowData)}</div>
            {defMembership?.role !== "VIEWER" && (
                <div className="subscriber-detail-mobile-section subscriber-detail-mobile-actions">
                    {actionBodyTemplate(rowData)}
                </div>
            )}
        </div>
    );

    const upcomingMobileSummary = (rowData) => (
        <div className="subscriber-detail-mobile-summary">
            <div className="subscriber-detail-mobile-section">{scheduledForBodyTemplate(rowData)}</div>
            <div className="subscriber-detail-mobile-section">{subscriptionsBodyTemplate(rowData)}</div>
            <div className="subscriber-detail-mobile-section subscriber-detail-mobile-section-last">
                {upcomingAmount(rowData)}
            </div>
        </div>
    );

    const secondaryCustomerTemplate = (rowData) => {
        if (!rowData) return null;
        const phone = rowData.phoneNo
            || rowData.phoneNumber
            || rowData.businessCustomer?.phoneNo;
        return (
            <div className="customer_info">
                {rowData.id ? (
                    <span
                        className="customerReference detail-navigation"
                        onClick={() => routeChange(`/crm/customers/customer/${rowData.id}`)}
                    >
                        {rowData.id}
                    </span>
                ) : null}
                <div className="customer_name_row">
                    <span
                        className="customer_name detail-navigation"
                        onClick={() => rowData.id && routeChange(`/crm/customers/customer/${rowData.id}`)}
                    >
                        {rowData.name || "null"}
                    </span>
                </div>
                {phone ? <span className="customer_data">{removePlusFromNum(phone)}</span> : null}
                {rowData.email ? <span className="customer_data">{rowData.email}</span> : null}
            </div>
        );
    };

    const secondaryIdentifiersTemplate = (rowData) => {
        if (!rowData) return null;
        return (
            <div className="subscriber-detail-relation-cell">
                {rowData.customerNum ? (
                    <div className="subscriber-detail-relation-id">
                        <span className="sub-label">{t("business_customers.customer_ref")}</span>
                        <span className="subscriber-detail-relation-id__value">{rowData.customerNum}</span>
                    </div>
                ) : null}
                {rowData.reference ? (
                    <div className="subscriber-detail-relation-id">
                        <span className="sub-label">{t("business_customers.reveknew_id")}</span>
                        <span className="subscriber-detail-relation-id__value">{rowData.reference}</span>
                    </div>
                ) : null}
            </div>
        );
    };

    const secondaryStatusTemplate = (rowData) => {
        if (!rowData) return null;
        return (
            <div className="subscriber-detail-relation-cell">
                <span className="d-block">
                    {rowData.linkedOn ? formatDateTime(rowData.linkedOn) : "null"}
                </span>
                {rowData.linkReason ? (
                    <span className="d-block">
                        {t("business_customers.link_reason")}: {rowData.linkReason}
                    </span>
                ) : null}
            </div>
        );
    };

    const secondaryStatTemplate = (rowData, pick) => {
        const stats = relations.secondariesStatsById?.[rowData?.id];
        if (relations.secondariesStatsLoading && !stats) {
            return <span className="subscriber-detail-secondary-stat__loading">{t("common.loading")}</span>;
        }
        if (!stats) return "—";
        const amount = pick === "collected" ? stats.collectedAmount : stats.externalAmount;
        const count = pick === "collected" ? stats.totalPayments : stats.totalExternalPayments;
        return (
            <div className="subscriber-detail-secondary-stat">
                <FormatCurrency
                    amount={amount}
                    currencySymbol={currencySymbol}
                    currencyFormat={currencyFormat}
                    className="business-customer-amnt"
                />
                <span className="num_payments">
                    {t(
                        Number(count) === 1
                            ? "business_customers.stat_payments_count_one"
                            : "business_customers.stat_payments_count_other",
                        { count: Number(count) || 0 }
                    )}
                </span>
            </div>
        );
    };

    const secondaryActiveTemplate = (rowData) => {
        const stats = relations.secondariesStatsById?.[rowData?.id];
        if (relations.secondariesStatsLoading && !stats) {
            return <span className="subscriber-detail-secondary-stat__loading">{t("common.loading")}</span>;
        }
        const count = Number(stats?.activeSubs) || 0;
        return (
            <div className="subscriber-detail-secondary-stat">
                <span className="successCount_span">{count}</span>
                <span className="num_payments">{t("subscriptions")}</span>
            </div>
        );
    };

    const linkedPlanPolicyBadges = (plan) => {
        if (!plan?.policy) return null;
        if (plan.policy === "TARGET") {
            return (
                <span className="flex">
                    <p className="text-left policy mb-0 mr-2">{t("billing", { val: plan.policy })}</p>
                    <p className="text-left policy target-stat mb-0 mr-1">
                        {plan.targetEqualParts ? t("product.equal") : t("product.varying")}
                    </p>
                    {plan.targetEqualParts && plan.recoverMissed ? (
                        <p className="text-left policy target-stat-miss mb-0">{t("product.recovery")}</p>
                    ) : null}
                </span>
            );
        }
        return (
            <p className="text-left policy mb-0">
                {plan.policy === "FIXED"
                    ? t("products.fixed_billing").toUpperCase()
                    : plan.policy === "CUSTOM"
                        ? t("products.custom_billing").toUpperCase()
                        : t("billing", { val: plan.policy })}
            </p>
        );
    };

    const linkedPlanAmountLine = (plan) => {
        if (!plan) return null;
        if (plan.policy === "SCHEDULE") return <span>null</span>;
        if (plan.policy === "FLEXIBLE" || plan.flex) {
            return <p className="mb-0">{t("business_customers.flex")}</p>;
        }
        if (plan.policy === "CUSTOM" && (plan.cost == null || plan.cost === "")) {
            return <p className="mb-0">{t("amount_fixed")}</p>;
        }
        const amount = plan.policy === "TARGET" ? plan.target : plan.cost;
        if (amount == null || amount === "") return null;
        return (
            <FormatCurrency
                amount={amount}
                currencySymbol={currencySymbol}
                currencyFormat={currencyFormat}
                className=""
            />
        );
    };

    const linkedPlanInfoTemplate = (rowData) => {
        if (!rowData) return null;
        const planId = planIdOf(rowData);
        const groupName = rowData.groupName || rowData.group?.name;
        const groupId = rowData.groupId || rowData.group?.id;
        const setupFee = rowData.setup ?? rowData.setupCost;
        return (
            <div className="subscriptionMainBodyTemplate subscriptionBodyTemplate_customers">
                {linkedPlanPolicyBadges(rowData)}
                {rowData.name ? (
                    <div className="flex align-items-center gap-2">
                        <span
                            className="detail-navigation tier-name-content"
                            onClick={() => {
                                if (planId) navigate(`/products/plan/detail/${planId}`);
                            }}
                        >
                            {rowData.name}
                        </span>
                        <AutoBillingBadge collectionMode={rowData.collectionMode} />
                    </div>
                ) : null}
                {linkedPlanAmountLine(rowData)}
                {rowData.billingPeriod ? (
                    <span className="plan-group-text">
                        {t(`product.${String(rowData.billingPeriod).toLowerCase()}`)}
                    </span>
                ) : null}
                {groupName ? (
                    <span
                        className={groupId ? "plan-text detail-navigation hov" : "plan-text"}
                        onClick={() => {
                            if (groupId) navigate(`/products/detail/${groupId}`);
                        }}
                    >
                        {groupName}
                    </span>
                ) : null}
                {setupFee ? (
                    <div className="setup_fee_main_div setup_pt">
                        <span className="setup_fee_tag">{t("common.setup_fee_label")}</span>
                        <FormatCurrency
                            amount={setupFee}
                            currencySymbol={currencySymbol}
                            currencyFormat={currencyFormat}
                            className="setup_fee_value"
                        />
                    </div>
                ) : null}
            </div>
        );
    };

    const linkedPlanStatusTemplate = (rowData) => {
        const status = rowData?.status;
        if (!status) return "null";
        return (
            <span className={`status-outline status-${String(status).toLowerCase()} status_body`}>
                {status}
            </span>
        );
    };

    const secondariesMobileSummary = (rowData) => (
        <div className="subscriber-detail-mobile-summary">
            <div className="subscriber-detail-mobile-section">{secondaryStatusTemplate(rowData)}</div>
            <div className="subscriber-detail-mobile-section">{secondaryCustomerTemplate(rowData)}</div>
            <div className="subscriber-detail-mobile-section">{secondaryIdentifiersTemplate(rowData)}</div>
            <div className="subscriber-detail-mobile-section">{secondaryStatTemplate(rowData, "collected")}</div>
            <div className="subscriber-detail-mobile-section">{secondaryStatTemplate(rowData, "external")}</div>
            <div className="subscriber-detail-mobile-section subscriber-detail-mobile-section-last">
                {secondaryActiveTemplate(rowData)}
            </div>
        </div>
    );

    const linkedPlansMobileSummary = (rowData) => (
        <div className="subscriber-detail-mobile-summary">
            <div className="subscriber-detail-mobile-section">{linkedPlanInfoTemplate(rowData)}</div>
            <div className="subscriber-detail-mobile-section subscriber-detail-mobile-section-last">
                {linkedPlanStatusTemplate(rowData)}
            </div>
        </div>
    );

    const pageItems = (items) => {
        const list = Array.isArray(items) ? items : [];
        return list.slice(state.first, state.first + state.size).map((row, index) => ({
            ...row,
            id: row?.id ?? `relation-${state.first + index}`,
        }));
    };

    const tabs = [{
        key: TAB_STATEMENT,
        label: "business_customers.statement_of_accounts",
        columns: [],
        value: [],
        count: 0,
        paginator: false,
        index: 0,
    },
    {
        key: TAB_SUBSCRIPTIONS,
        label: "subscriber.title", columns: [
            { field: 'status', body: statusBodyTemplate, header: t("business_customers.status"), headerClassName: "amount-header", bodyClassName: "status-body", alignHeader: "left" },
            { field: 'subscriber', body: subscriptionBodyTemplate, header: t("subscriber.info"), headerClassName: "subsTemplate-header", bodyClassName: "status" },
            { field: 'subscriber.cost', body: amountTemplate, header: t("dashboard.amount"), headerClassName: "amount-header", bodyClassName: "status amount-cell", align: "left", alignHeader: "left" },
            { field: "collectedAmount", body: paymentBodyTemplate, header: t("business_customers.payment"), headerClassName: "subsTemplate-header" },
            { body: actionBodyTemplate, headerClassName: "subsTemplate-header", bodyClassName: "subscriber-detail-actions" },
        ],
        value: state.businessCustomerSummary, count: state.totalCustomerSummaryCount, paginator: true, index: 1
    },
    {
        key: TAB_UPCOMING,
        label: "subscriber.upcoming", columns: [
            { field: 'scheduledFor', body: scheduledForBodyTemplate, header: t("products.payment_schedule"), headerClassName: "amount-header", bodyClassName: "status-body" },
            { field: 'subscriber', body: subscriptionsBodyTemplate, header: t("business_customers.subscription_info"), headerClassName: "subsTemplate-header", bodyClassName: "status" },
            { field: 'subscriber.cost', body: upcomingAmount, header: t("dashboard.amount"), headerClassName: "amount-header", bodyClassName: "status amount-cell", align: "left", alignHeader: "left" },
        ],
        value: state.upcomingPayments, count: state.totalUpcomingPaymentsCount, paginator: true, index: 2
    }
    ];

    if (relations.showSecondariesCue) {
        tabs.push({
            key: TAB_SECONDARIES,
            label: "business_customers.secondaries_summary",
            columns: [
                { field: "linkedOn", body: secondaryStatusTemplate, header: t("business_customers.linked_on"), headerClassName: "amount-header", bodyClassName: "status-body", alignHeader: "left" },
                { field: "customer", body: secondaryCustomerTemplate, header: t("business_customers.customer_info"), headerClassName: "subsTemplate-header", bodyClassName: "status" },
                { field: "identifiers", body: secondaryIdentifiersTemplate, header: t("business_customers.customer_ref"), headerClassName: "subsTemplate-header" },
                { field: "collected", body: (row) => secondaryStatTemplate(row, "collected"), header: t("business_customers.paid"), headerClassName: "amount-header", alignHeader: "left" },
                { field: "external", body: (row) => secondaryStatTemplate(row, "external"), header: t("business_customers.external"), headerClassName: "amount-header", alignHeader: "left" },
                { field: "activeSubs", body: secondaryActiveTemplate, header: t("business_customers.active_subs"), headerClassName: "amount-header", alignHeader: "left" },
            ],
            value: pageItems(relations.secondaries),
            count: relations.secondaries.length,
            paginator: true,
            index: tabs.length,
        });
    }

    if (relations.showLinkedPlansCue) {
        tabs.push({
            key: TAB_LINKED_PLANS,
            label: "business_customers.linked_plans",
            columns: [
                { field: "plan", body: linkedPlanInfoTemplate, header: t("product.plan_info"), headerClassName: "subsTemplate-header", bodyClassName: "status" },
                { field: "status", body: linkedPlanStatusTemplate, header: t("subscriber.status"), headerClassName: "amount-header", bodyClassName: "status-body", alignHeader: "left" },
            ],
            value: pageItems(relations.linkedPlans),
            count: relations.linkedPlans.length,
            paginator: true,
            index: tabs.length,
        });
    }

    const activeTab = Math.max(0, tabs.findIndex((tab) => tab.key === activeTabKey));
    const currentTab = tabs[activeTab] || tabs[0];

    const handleSetActiveTab = (index) => {
        const nextKey = tabs[index]?.key;
        if (nextKey) setActiveTabKey(nextKey);
    };

    const openRelationTab = (tabKey) => (event) => {
        event?.preventDefault?.();
        event?.stopPropagation?.();
        setActiveTabKey(tabKey);
        setState((prev) => ({ ...prev, page: 0, first: 0 }));
        requestAnimationFrame(() => {
            document.getElementById(SUBSCRIBER_DETAIL_TABLE_ID)?.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        });
    };

    const getDisplayColumns = (tab) => {
        if (!isMobileStack) {
            return tab.columns;
        }

        const mobileBody = {
            [TAB_SUBSCRIPTIONS]: subscriptionsMobileSummary,
            [TAB_UPCOMING]: upcomingMobileSummary,
            [TAB_SECONDARIES]: secondariesMobileSummary,
            [TAB_LINKED_PLANS]: linkedPlansMobileSummary,
        }[tab.key];

        return [{
            field: "mobileSummary",
            header: t(tab.label),
            body: mobileBody,
            className: "subscriber-detail-mobile-summary-column",
        }];
    };


    const receivedPayments = state.businessCustomerSubscriptions.map((receivedPayments) => {
        return (receivedPayments.status === "ACTIVE" && receivedPayments.successCount)
    })

    const activeSubscriptions = state.businessCustomerSubscriptions.map((activeSubscriptions) => {
        return (activeSubscriptions.status === "ACTIVE" ? 1 : 0)
    })

    const totalActiveSubscriptions = activeSubscriptions.reduce((a, b) => a + b, 0);

    const totalReceivedPayments = receivedPayments.reduce((a, b) => a + b, 0);

    const closeDisplayBasic = () => {
        setDisplayBasic(false)
    };


    const pauseSubscriptionActions = (
        <div className="cus_pauseSubscriptionActions">
            <Button label={t('common.no')} icon="pi pi-times" className="p-button-text" id="pause_no_btn"
                onClick={() => { setConfirmPause(false) }}
            />
            <Button label={t('common.yes')} icon="pi pi-check" loading={pausingSubscription}
                id="pause_yes_btn"
                onClick={() => {
                    pauseSubscriptions(state.subscriptionId, defMembership.id);
                    setState((state) => { return { ...state, paused: true } })
                }}
                autoFocus />
        </div>
    );

    const cancelSubscriptionActions = (
        <div className="cus_cancelSubscriptionActions">
            <Button label={t('common.no')} icon="pi pi-times" className="p-button-text" id="cancelSubs_no_btn"
                onClick={() => { setConfirmCancel(false) }}
            />
            <Button label={t('common.yes')} icon="pi pi-check" loading={cancellingSubscription}
                id="cancelSubs_yes_btn"
                onClick={() => {
                    cancelSubscriptions(state.subscriptionId, defMembership.id);
                    setState((state) => { return { ...state, cancelled: true } })
                }}
                autoFocus />
        </div>
    );

    const newDate = formatDate(date)

    const resumeSubscriptionActions = (
        <div className="cus_resumeSubscriptionActions">
            <Button label={t('common.no')} icon="pi pi-times" className="p-button-text"
                id="resume_no_btn"
                onClick={() => { setConfirmResume(false) }}
            />
            <Button label={t('common.yes')} icon="pi pi-check" loading={resumingSubscription} disabled={!date}
                id="resumeSubs_yes_btn"
                onClick={() => {
                    resumeSubscriptions(state.subscriptionId, newDate, defMembership.id, "RESUME")
                    setState((state) => { return { ...state, resumed: true, key: true } })
                }}
                autoFocus />
        </div>
    );

    const rescheduleSubscriptionActions = (
        <div className="subs-actions-footer">
            <Button label={t('subscriber.cancel')} icon="pi pi-times" className="p-button-text"
                id="reschedule_no_btn"
                onClick={() => { setConfirmReschedule(false) }}
            />
            <Button label={t('subscriber.reschedule')} icon="pi pi-check" loading={reschedulingSubscription} disabled={!date}
                id="reschedule_confirm_btn"
                onClick={() => {
                    rescheduleSubscriptions(state.subscriptionId, newDate, defMembership.id);
                    setState((state) => { return { ...state, rescheduled: true, key: true } })
                }}
                autoFocus />
        </div>
    );

    const unlinkCustomerActions = (
        <div className="cus_unlinkCustomerActions">
            <Button
                label={t("common.no")}
                icon="pi pi-times"
                className="p-button-text"
                onClick={() => setConfirmUnlink(false)}
                disabled={unlinkingCustomer}
            />
            <Button
                label={t("common.yes")}
                icon="pi pi-check"
                id="unlink_yes_btn"
                loading={unlinkingCustomer}
                disabled={unlinkingCustomer}
                onClick={handleUnlinkCustomer}
                autoFocus
            />
        </div>
    );

    const toggleInvite = () => {
        setVisibleInvite(false)
    }

    let today = new Date();
    const phoneNumber = state.customerRecord?.phoneNo

    const onChange = (e) => {
        if (e.pageCount <= 1) {
            return;
        }
        if (currentTab?.key === TAB_SUBSCRIPTIONS) {
            getCustomerReceivedPayments(customerId, { page: e.page, sort: state.subsSort, size: state.size })
            setState((state) => { return { ...state, page: e.page, first: e.first } })
        } else if (currentTab?.key === TAB_UPCOMING) {
            getBusinessCustomerUpcomingPayments(customerId, { page: e.page, sort: state.upSort, size: state.size })
            setState((state) => { return { ...state, page: e.page, first: e.first } })
        } else {
            setState((state) => { return { ...state, page: e.page, first: e.first } })
        }
    }

    const totalNumber = currentTab?.key === TAB_SUBSCRIPTIONS
        ? state.totalCustomerSummaryCount
        : currentTab?.key === TAB_UPCOMING
            ? state.totalUpcomingPaymentsCount
            : currentTab?.count ?? 0

    const loadingSpinner = currentTab?.key === TAB_SECONDARIES
        ? relations.fetchingSecondaries
        : currentTab?.key === TAB_LINKED_PLANS
            ? relations.fetchingLinkedPlans
            : fetchingCustomerCollectedPayments || fetchingCustomerSubscriptions || fetchingCustomerReceivedPayments || fetchingPending;

    const emptyMessage = currentTab?.key === TAB_SECONDARIES
        ? t("business_customers.no_secondaries")
        : currentTab?.key === TAB_LINKED_PLANS
            ? t("business_customers.no_linked_plans")
            : undefined

    const subscriptionChoice = (row) => {
        const subscriber = row?.subscriber?.plan || row?.subscriber?.subscriberReference ? row.subscriber : row;
        const planName = subscriber?.plan?.name || subscriber?.planName || "";
        const productName = subscriber?.plan?.groupName || subscriber?.plan?.group?.name || "";
        const reference = subscriber?.subscriberReference || row?.reference || "";
        return {
            planName: planName || reference || t("subscriber.title"),
            detail: [productName, planName ? reference : ""].filter(Boolean).join(" · "),
        };
    };

    const eligibleSubscriptions = (action) => {
        const rows = Array.isArray(toPlain(state.businessCustomerSubscriptions))
            ? toPlain(state.businessCustomerSubscriptions)
            : [];
        if (action === "pause") return rows.filter((row) => row?.status === "ACTIVE");
        if (action === "resume") return rows.filter((row) => row?.status === "PAUSED");
        return rows.filter((row) => row?.status === "ACTIVE" || row?.status === "PAUSED");
    };

    const openSubscriptionAction = (action, row) => {
        setSelectedSubscription(subscriptionChoice(row));
        setState((current) => ({ ...current, subscriptionId: row.id }));
        setSubscriptionPicker(null);
        if (action === "pause") setConfirmPause(true);
        else if (action === "resume") setConfirmResume(true);
        else setConfirmCancel(true);
    };

    const startSubscriptionAction = (action) => {
        const rows = eligibleSubscriptions(action);
        if (rows.length === 1) {
            openSubscriptionAction(action, rows[0]);
            return;
        }
        if (rows.length > 1) setSubscriptionPicker({ action, rows });
    };

    const subscriptionPickerRows = (subscriptionPicker?.rows || []).map((row) => ({
        id: row.id,
        ...subscriptionChoice(row),
        row,
        action: subscriptionPicker.action,
    }));

    return (
        <div className="subscriber-detail-screen">
            <Toast ref={cancelToast} />
            <Toast ref={pauseToast} />
            <Toast ref={resumeToast} />
            <Toast ref={rescheduleToast} />
            <Toast ref={linkPlanToast} />
            <Toast ref={linkCustomerToast} />

            <CustomerEdit displayBasic={displayBasic} onHide={closeDisplayBasic} id={state.id} state={state} setState={setState} />

            <InviteSubscriber visible={state.visible} header={t("business_customers.invite")}
                toggleVisible={visibleInvite} onHide={toggleInvite} initialTier={null} phoneNo={phoneNumber}
                businessCustomer={state.customerRecord} />
            <MarkAsPaid displayDialog={visible} onHide={() => { setVisible(false) }}
                scheduledFor={state.scheduledFor}
                scheduleId={state.id}
                isFlexTrue={state.flex}
                callbackFunctions={() => {
                    getEnterpriseCustomers(defMembership.business.id)
                    getBusinessCustomerSubscriptions(customerId)
                    getBusinessCustomerRecord(customerId)
                    getRecentCustomerPayments(customerId, "3")
                    getRecentMissedCustomerPayments(customerId, "3")
                    getRecentSubscriptionActivity(customerId, "3")
                    getCustomerPendingPayments(customerId)
                    getCustomerReceivedPayments(customerId)
                }}
            />
            <Dialog
                visible={!!subscriptionPicker}
                style={{ width: "28rem" }}
                onHide={() => setSubscriptionPicker(null)}
                header={t("subscriber.choose_subscription")}
            >
                <div className="subscriber-detail-subscription-picker">
                    {subscriptionPickerRows.map(({ id, planName, detail, row, action }) => (
                        <button
                            type="button"
                            key={id}
                            className="subscriber-detail-subscription-picker__item"
                            onClick={() => openSubscriptionAction(action, row)}
                        >
                            <span className="subscriber-detail-subscription-picker__plan">{planName}</span>
                            {detail ? <span className="subscriber-detail-subscription-picker__detail">{detail}</span> : null}
                        </button>
                    ))}
                </div>
            </Dialog>
            <Dialog
                visible={confirmPause}
                style={{ width: "auto" }}
                onHide={() => setConfirmPause(false)}
                header={t("subscriber.confirmation_header")}
                footer={pauseSubscriptionActions}
            >
                {<h6>{t("subscriber.pause_confirmation_message")}</h6>}
            </Dialog>
            <Dialog onHide={() => setConfirmReschedule(false)} visible={confirmReschedule} header={t("subscriber.reschedule_label")}
                footer={rescheduleSubscriptionActions} style={{ width: "23rem" }}>
                {
                    <div className="field  reschedule-date">
                        <Calendar
                            id="startDate"
                            name="startDate"
                            value={date}
                            minDate={today}
                            readOnlyInput
                            onChange={(e) => setDate(e.value)} showIcon
                            placeholder={t("subscriber.rescheduling_date")}
                            className="p-datepicker-header"
                        />
                    </div>
                }
            </Dialog>
            <Dialog
                visible={confirmCancel}
                style={{ width: "auto" }}
                onHide={() => setConfirmCancel(false)}
                header={t("subscriber.confirmation_header")}
                footer={cancelSubscriptionActions}
            >
                {<h6>{t("subscriber.cancel_confirmation_message")}</h6>}
            </Dialog>
            <Dialog
                onHide={() => setConfirmResume(false)}
                visible={confirmResume}
                header={t("subscriber.resume_label")}
                footer={resumeSubscriptionActions}
                style={{ width: "350px" }}
                className="tier_dialog"
            >
                {
                    <div className="field col-12" style={{ width: "100%" }}>
                        {selectedSubscription ? (
                            <div className="subscriber-detail-resume-target">
                                <span className="subscriber-detail-subscription-picker__plan">{selectedSubscription.planName}</span>
                                {selectedSubscription.detail ? (
                                    <span className="subscriber-detail-subscription-picker__detail">{selectedSubscription.detail}</span>
                                ) : null}
                            </div>
                        ) : null}
                        <Calendar
                            id="startDate"
                            name="startDate"
                            value={date}
                            minDate={today}
                            dateFormat={calenderDateFormat}
                            readOnlyInput
                            onChange={(e) => setDate(e.value)} showIcon
                            placeholder={t("subscriber.resumption_date")}
                            className="p-datepicker-header subscriber-detail-resume-calendar"
                            style={{ width: "100%" }}
                        />
                    </div>
                }
            </Dialog>

            <Dialog
                visible={confirmUnlink}
                style={{ width: "auto" }}
                onHide={() => {
                    if (!unlinkingCustomer) setConfirmUnlink(false);
                }}
                header={t("business_customers.unlink_confirmation_header")}
                footer={unlinkCustomerActions}
                dismissableMask={!unlinkingCustomer}
                closable={!unlinkingCustomer}
            >
                <h6>{t("business_customers.unlink_confirmation_message")}</h6>
            </Dialog>

            <DetailCard {...{
                state, t, totalActiveSubscriptions, defMembership, totalReceivedPayments,
                setDisplayBasic, setState, customerId, setVisibleInvite,
                onOpenLinkPlan: openPlanLinkModal,
                onOpenLinkCustomer: openCustomerLinkModal,
                onUnlinkCustomer: openUnlinkConfirm,
                onViewPrimary: openPrimaryModal,
                linkedToPrimary,
                unlinkingCustomer,
                relationsRefreshKey,
                onRelationsChange: handleRelationsChange,
                onSecondariesCueClick: openRelationTab(TAB_SECONDARIES),
                onLinkedPlansCueClick: openRelationTab(TAB_LINKED_PLANS),
                onOpenSegmentDialog: handleOpenSegmentDialog,
                onOpenAddTag: handleOpenAddTag,
                onRemoveTag: handleOpenRemoveTag,
                onPauseSubscription: () => startSubscriptionAction("pause"),
                onResumeSubscription: () => startSubscriptionAction("resume"),
                onCancelSubscription: () => startSubscriptionAction("cancel"),
            }} />

            <SubscriberToSegment
                visible={segmentDialogVisible}
                onHide={() => {
                    setSegmentDialogVisible(false);
                    setSwitchSegVisible(false);
                }}
                header={switchSegVisible
                    ? t("segment.switch_seg_")
                    : t("segment.add_subscriber_title")}
                saveLabel={switchSegVisible
                    ? t("segment.switch_seg_btn")
                    : t("segment.add_subs")}
                removeLabelClicked={false}
                businessId={defMembership?.business?.id}
                setSelectedSubscribers={setSelectedCustomers}
                selectedSubscribers={selectedCustomers}
                customersCall={refreshCustomerSegmentAndTags}
                pageOptions={{}}
                rowSubClicked={buildRowSubClicked()}
            />

            <AddSubscribersToTagDialog
                visible={displayAddTag}
                onHide={() => setDisplayAddTag(false)}
                selectedCustomers={selectedCustomers}
                setSelectedCustomers={setSelectedCustomers}
                rowSubClicked={buildRowSubClicked()}
                refreshCustomers={refreshCustomerSegmentAndTags}
            />

            <RemoveSubscribersDialog
                visible={displayRemoveTag}
                onHide={() => {
                    setDisplayRemoveTag(false);
                    setSpecificTagClicked(null);
                }}
                selectedCustomers={selectedCustomers}
                setSelectedCustomers={setSelectedCustomers}
                removeDialogClick={displayRemoveTag}
                rowSubClicked={buildRowSubClicked()}
                specificTagClicked={specificTagClicked}
                refreshCustomers={refreshCustomerSegmentAndTags}
            />

            <LinkPlanBusinessCustomerModal
                visible={planLinkModalOpen}
                onHide={closePlanLinkModal}
                customerId={customerId}
                customerName={state.customerRecord?.name}
                customerPhoneNo={state.customerRecord?.phoneNo}
                recentSubPlan={recentSubPlan}
                planGroups={planGroupsForLink}
                fetchingPlans={fetchingPlans}
                selectedPlanIds={planLinkForm.planIds}
                onPlanChange={(planIds) => setPlanLinkForm({ planIds })}
                onSubmit={handlePlanLinkSubmit}
                linking={linkingPlan}
                submitAttempted={planLinkSubmitAttempted}
                submitError={planLinkSubmitAttempted && !!errorLinkingPlan}
            />

            <LinkBusinessCustomerModal
                visible={customerLinkModalOpen}
                onHide={closeCustomerLinkModal}
                businessId={defMembership?.business?.id}
                sourceCustomer={{
                    bcId: customerId,
                    name: state.customerRecord?.name,
                    phoneNo: state.customerRecord?.phoneNo,
                    segment: state.customerRecord?.segment?.name ?? null,
                    tags: state.customerSummary?.tags ?? [],
                }}
                onLinkPrimary={handleLinkPrimaryCustomer}
                linking={linkingCustomer}
                linkError={customerLinkError && !!errorLinkingCustomer}
            />

            <PrimaryBusinessCustomerModal
                visible={primaryModalOpen}
                onHide={closePrimaryModal}
                secondaryCustomer={{
                    bcId: customerId,
                    name: state.customerRecord?.name,
                    phoneNo: state.customerRecord?.phoneNo,
                    segment: state.customerRecord?.segment?.name ?? null,
                    tags: state.customerSummary?.tags ?? [],
                }}
                primaryCustomerId={primaryCustomerId}
                currencySymbol={currencySymbol}
                currencyFormat={currencyFormat}
            />

            <CollectPayment
                {...{ state, setState, membershipId, countryCurrency, defMembership }}
                callBack={() => getCustomerReceivedPayments(customerId, { sort: state.subsSort, size: state.size })}
            />

            <RecordPayment
                {...{ state, setState, membershipId, calenderDateFormat, countryCurrency, defMembership }}
                callBack={() => getCustomerReceivedPayments(customerId, { sort: state.subsSort, size: state.size })
                }
            />

            <div id={SUBSCRIBER_DETAIL_TABLE_ID} className="detail_card subscriber-detail-table-card">
                <CustomDataTable
                    key={`${activeTabKey}-${isMobileStack}`}
                    value={currentTab.value}
                    columns={getDisplayColumns(currentTab)}
                    tabs={tabs.map(({ label, i }) => ({ label, i }))}
                    setActiveTab={handleSetActiveTab}
                    activeTab={activeTab}
                    setState={setState}
                    tableClassName="tier_detail_data_table ml-0 subscriber-detail-data-table"
                    title="business_customers.table_title"
                    children={null}
                    rows={state.size}
                    loading={loadingSpinner}
                    tab={state.tabChange}
                    emptyMessage={emptyMessage}
                    tabBodyContent={(tabIndex) => (
                        tabs[tabIndex]?.key === TAB_STATEMENT
                            ? <StatementOfAccountTab customerId={customerId} />
                            : null
                    )}
                    responsiveLayout="stack"
                    scrollable={!isMobileStack}
                    scrollHeight={isMobileStack ? undefined : "flex"}
                />
                {currentTab?.key !== TAB_STATEMENT && <Paginator
                    className="customer_detail_pagination custom-paginator subscriber-detail-paginator"
                    rows={state.size}
                    first={state.first}
                    totalRecords={totalNumber}
                    onPageChange={onChange}
                />}
            </div>
        </div >
    )
}
export default BusinessCustomers